import GUI from 'lil-gui';

const GRASS_MAP_NAMES = ['map', 'normalMap', 'roughnessMap'];

export function createGrassMaterialDebugUI(grassMaterial) {
   const params = {
      textureScale: grassMaterial.map.repeat.x,
   };
   const gui = new GUI({ title: 'Grass Material' });

   gui.add(params, 'textureScale', 0.1, 50, 0.1).onChange((value) => {
      for (const mapName of GRASS_MAP_NAMES) {
         grassMaterial[mapName]?.repeat.set(value, value);
      }
   });
   gui.add(
      {
         copy: () => {
            console.log('Grass Material Values:', params);
         },
      },
      'copy',
   ).name('Copy to Console');

   return { gui, getValues: () => ({ ...params }) };
}
